class CollectionHeroFacets extends HTMLElement {
  constructor() {
    super();

    this.filterQuery = {
      categories: [],
      size: [],
      colours: [],
      features: [],
    };

    //default 2 -> 2 or 4
    this.currentViews = 2;

    this.elements = {
      filterButton: this.querySelector('.js-filters'),
      viewButtons: this.querySelectorAll('.js-viewButtons'),
      categoryFilters: this.querySelectorAll('.js-categoryFilters'),
      applyFiltersButton: this.querySelector('.js-btn-apply-filters'),
      clearFiltersButton: this.querySelector('.js-btn-clear-filters'),
      parentContainer: this.parentNode,
    };

    // this.elements.filterButton.addEventListener('click', this.handleFiltersOpening.bind(this));
    this.elements.viewButtons.forEach((button) => {
      button.addEventListener('click', this.handleViewSwitch.bind(this, button));
    });
    this.elements.categoryFilters.forEach((button) => {
      button.querySelector('input').addEventListener('change', this.handleCategoryFilters.bind(this, button));
    });

    // this.elements.applyFiltersButton.addEventListener('click', this.handleApplyFilters);
    // this.elements.clearFiltersButton.addEventListener('click', this.handleClearFilters);
    const stickyElm = this.elements.parentContainer;

    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        stickyElm.classList.remove('scrolling-up');
        stickyElm.classList.add('scrolling-down');
      } else {
        stickyElm.classList.remove('scrolling-down');
        stickyElm.classList.add('scrolling-up');
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });

    const observer = new IntersectionObserver(
      ([e]) => {
        e.target.classList.toggle('stickyCollectionVisible', e.intersectionRatio < 1);
      },
      {
        threshold: [1],
      }
    );

    observer.observe(stickyElm);

    this.viewsTrigger();

    var windowWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (window.innerWidth != windowWidth) {
        // Update the window width for next time
        windowWidth = window.innerWidth;
        // Do stuff here
        this.viewsTrigger();
      }
    });
  }

  handleApplyFilters() {
    console.log(' Apply filters ');
  }

  handleFiltersOpening() {
    this.renderSectionFromFetch();
    this.classList.add('active');
  }

  handleClearFilters() {
    console.log('Clear filters');
  }

  handleViewSwitch(button) {
    var viewColumns = button.dataset.view;
    var productContainer = document.querySelector('.js-collection-hero-facet');
    var editorialImage = document.querySelector('.editorial-grid-item');

    productContainer.classList.remove('display-grid--cols-4');
    productContainer.classList.remove('display-grid--cols-2');
    productContainer.classList.remove('display-grid--cols-1');
    productContainer.classList.add(`display-grid--cols-${viewColumns}`);

    this.elements.viewButtons.forEach((viewButton) => viewButton.classList.remove('active'));
    button.classList.add('active');

    if (viewColumns == 2) {
      productContainer.classList.add('extra-padding');
    } else {
      productContainer.classList.remove('extra-padding');
    }
  }

  viewsTrigger() {
    if (window.innerWidth < 759) {
      this.querySelector('.js-trigger-view-1').click();
    } else {
      this.querySelector('.js-trigger-view-4').click();
    }
  }

  renderSectionFromFetch() {
    var id = document.getElementById('product-grid').dataset.id;
    const url = `${window.location.pathname}?section_id=${id}`;

    fetch(url)
      // .then((response) => response.text())
      .then((responseText) => {
        console.log(responseText);
      });
  }

  handleCategoryFilters(button) {
    var handle = button.dataset.handle;

    if (button.querySelector('input').checked) {
      this.filterQuery['categories'].push(handle);
    } else {
      this.filterQuery['categories'] = this.filterQuery['categories'].filter((item) => item != handle);
    }
  }
}

customElements.define('collection-hero-facets', CollectionHeroFacets);

class FilterDrawer extends HTMLElement {
  constructor() {
    super();

    this.testField = 'test';

    var openDrawer = document.querySelectorAll('.js-modal-drawer-open-filters');

    openDrawer.forEach((drawerBtn) => {
      drawerBtn.addEventListener('click', () => {
        this.classList.add('active');
        this.isOpen = true;
      });
    });
  }

  connectedCallback() {
    var closeDrawer = this.querySelector('.icon-close');

    closeDrawer.addEventListener('click', () => {
      this.closeModal();
    });

    this.querySelector('.js-btn-apply-filters').addEventListener('click', () => {
      this.closeModal();
    });
    // clicking outside this should closeModal as well
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.closeModal();
      }
    });
  }

  closeModal() {
    this.classList.remove('active');
    this.isOpen = false;
  }
}

customElements.define('filter-drawer', FilterDrawer);
